module.exports = __webpack_public_path__ + "img/doc_active.832c7e2a.svg";